import React, { lazy, Suspense } from "react";
import { Spin } from "antd";
// eslint-disable-next-line no-unused-vars
import { element } from "prop-types";

// Enhanced loading component with Ant Design Spin
const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <Spin size="large" tip="Loading..." />
  </div>
);

// Optimized lazy loading wrapper
const lazyRoute = (importFn) => {
  const LazyComponent = lazy(importFn);
  return (
    <Suspense fallback={<LoadingFallback />}>
      <LazyComponent />
    </Suspense>
  );
};

export const mainRoutes = [
  {
    path: "/",
    element: lazyRoute(() => import("../pages/User/Login")),
  },
  {
    path: "*",
    element: lazyRoute(() => import("../pages/NotFound")),
  },
  {
    path: "/dashboard",
    element: lazyRoute(() => import("../pages/Dashboard")),
  },
  {
    path: "/allot-order",
    element: lazyRoute(() => import("../pages/Transactions/Allot")),
  },
  {
    path: "/allot-order-nonKit",
    element: lazyRoute(() => import("../pages/Transactions/AllotNonKit")),
  },
  {
    path: "/return-order",
    element: lazyRoute(() => import("../pages/Transactions/Return")),
  },
  {
    path: "/damage-swap",
    element: lazyRoute(() => import("../pages/Transactions/DamageSwap")),
  },
  {
    path: "/transfer-in",
    element: lazyRoute(() => import("../pages/Transactions/TransferIn")),
  },
  {
    path: "/transfer-out",
    element: lazyRoute(() => import("../pages/Transactions/TransferOut")),
  },
  // {
  //   path: "/transfer-out-nonKit",
  //   element: lazyRoute(() => import("../pages/Transactions/TransferOutNonKit")),
  // },
  // {
  //   path: "/bulk-transfers",
  //   element: lazyRoute(() => import("../pages/BulkUploads/Transfers")),
  // },
  {
    path: "/bulk-transfer-in",
    element: lazyRoute(() => import("../pages/BulkUploads/TransferIn/BulkTransferIN")),
  },
  {
    path: "/bulk-transfer-out",
    element: lazyRoute(() => import("../pages/BulkUploads/TransferOut")),
  },
  // {
  //   path: "/bulk-transfer-in",
  //   element: lazyRoute(() => import("../pages/BulkUploads/TransferIn")),
  // },
  // {
  //   path: "/bulk-allot-order",
  //   element: lazyRoute(() => import("../pages/BulkUploads/BulkAllot")),
  // },
  {
    path: "/layouts",
    element: lazyRoute(() => import("../pages/Layouts")),
  },
  {
    path: "/NotFound",
    element: lazyRoute(() => import("../pages/NotFound")),
  },
  {
    path: "/reports",
    element: lazyRoute(() => import("../pages/Reports")),
  },
  {
    path: "/settings",
    element: lazyRoute(() => import("../pages/User/Settings")),
  },
  {
    path: "/changepassword",
    element: lazyRoute(() =>
      import("../pages/User/MyProfile/Profile/ChangePassword")
    ),
  },
  {
    path: "/subscription",
    element: lazyRoute(() => import("../pages/ReportSubscription")),
  },
  {
    path: "/track-order",
    element: lazyRoute(() => import("../pages/TrackOrder")),
  },
  {
    path: "/Help&Support",
    element: lazyRoute(() => import("../pages/HelpSupport")),
  },
  {
    path: "/onlineGuide",
    element: lazyRoute(() => import("../pages/HelpSupport/OnlineGuide")),
  },
  {
    path: "/Faqs",
    element: lazyRoute(() => import("../pages/HelpSupport/Faqs")),
  },
  {
    path: "/RequestAssistance",
    element: lazyRoute(() => import("../pages/HelpSupport/RequestAssistance")),
  },
  {
    path: "/Documents",
    element: lazyRoute(() => import("../pages/HelpSupport/Documents")),
  },
  {
    path: "/jobs-tracker",
    element: lazyRoute(() => import("../pages/JobTracker")),
  },
  {
    path: "/download-pdf",
    element: lazyRoute(() => import("../pages/DownloadPDF")),
  },
  {
    path: "/user-requisition",
    element: lazyRoute(() => import("../pages/UserRequisition")),
  },
];
